import React from "react";
import styled from "styled-components";
import {Switch} from "antd";

const Box = styled.div`
    position: absolute;
    left: 10px;
    bottom: 10px;
    z-index: 1000;
    background: #ffffffe3;
    border-radius: 5px;
    padding: 8px 10px;
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

const Row = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    font-size: 13px;
`;

export const LiveOperationMapLayerSwitches = ({options, onChange}) => (
    <Box>
        <Row>
            <span>Alt Firma</span>
            <Switch
                size="small"
                checked={options.showSubCompanies}
                onChange={checked => onChange({...options, showSubCompanies: checked})}
            />
        </Row>
        <Row>
            <span>Sipariş</span>
            <Switch
                size="small"
                checked={options.showOrders}
                onChange={checked => onChange({...options, showOrders: checked})}
            />
        </Row>
        <Row>
            <span>Kurye</span>
            <Switch
                size="small"
                checked={options.showCouriers}
                onChange={checked => onChange({...options, showCouriers: checked})}
            />
        </Row>
    </Box>
);
